import { cn } from '@/lib/utils'
import { AllPurposeLink } from '@components/all-purpose-link'
import { DetailText, BodyText } from 'design-configuration/components/responsive-text'

export function TokenInfoListItem({
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  labelWithTooltip,
  className,
  href
}: {
  topLeft: React.ReactNode
  topRight: React.ReactNode
  bottomLeft: React.ReactNode
  bottomRight: React.ReactNode
  labelWithTooltip?: React.ReactNode
  className?: string
  href?: string
}): React.ReactElement {
  const content = (
    <div
      className={cn(
        'p-xs bg-surface-container flex justify-between border border-transparent',
        href ? 'hover:border-outline cursor-pointer' : '',
        className
      )}
    >
      <div className="flex flex-col justify-between">
        {labelWithTooltip ? (
          labelWithTooltip
        ) : (
          <DetailText className="text-on-surface-variant mb-xs font-medium uppercase">{topLeft}</DetailText>
        )}
        <BodyText className="text-on-surface font-medium">{bottomLeft}</BodyText>
      </div>
      <div className="flex flex-col items-end justify-between">
        <DetailText className="text-on-surface-variant mb-xs font-medium uppercase">{topRight}</DetailText>
        <BodyText className="text-on-surface-variant">{bottomRight}</BodyText>
      </div>
    </div>
  )

  return href ? <AllPurposeLink href={href}>{content}</AllPurposeLink> : content
}
